module.exports = __webpack_public_path__ + "88f8c3fd0604c28f3e665b1380e9d85a.svg";